// 按需引入 crypto-js 子模块,避免打包整个库 (~190KB → ~50KB)
import AES from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'
import encBase64 from 'crypto-js/enc-base64'
import modeECB from 'crypto-js/mode-ecb'
import padPkcs7 from 'crypto-js/pad-pkcs7'
// 仅用于类型标注,import type 在运行时被擦除,不会引入完整库
import type CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

type WordArray = CryptoJS.lib.WordArray

const RANDOM_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
const AES_KEY_LENGTH = 32

function generateRandomString(length = AES_KEY_LENGTH): string {
  const bytes = new Uint8Array(length)
  globalThis.crypto?.getRandomValues(bytes)

  if (bytes.some((byte) => byte !== 0)) {
    return Array.from(bytes, (byte) => RANDOM_CHARS[byte % RANDOM_CHARS.length]).join('')
  }

  return Array.from({ length }, () =>
    RANDOM_CHARS.charAt(Math.floor(Math.random() * RANDOM_CHARS.length)),
  ).join('')
}

export function generateAesKey(): WordArray {
  return encUtf8.parse(generateRandomString())
}

export function encryptBase64(value: WordArray): string {
  return encBase64.stringify(value)
}

export function decryptBase64(value: string): WordArray {
  return encBase64.parse(value)
}

export function encryptWithAes(message: string, aesKey: WordArray): string {
  return AES.encrypt(message, aesKey, {
    mode: modeECB,
    padding: padPkcs7,
  }).toString()
}

export function decryptWithAes(message: string, aesKey: WordArray): string {
  return AES.decrypt(message, aesKey, {
    mode: modeECB,
    padding: padPkcs7,
  }).toString(encUtf8)
}

export function encryptWithRsa(message: string, publicKey: string): string {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  const encrypted = encryptor.encrypt(message)
  if (!encrypted) {
    throw new Error('请求加密失败')
  }
  return encrypted
}

export function decryptWithRsa(message: string, privateKey: string): string {
  const decryptor = new JSEncrypt()
  decryptor.setPrivateKey(privateKey)
  const decrypted = decryptor.decrypt(message)
  if (!decrypted) {
    throw new Error('响应解密失败')
  }
  return decrypted
}
